import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '@qga/roo-ui/components';

import { mapOccupants } from '@shared/utils';

import Button from '@/components/Button';
import FormControl from '@/components/FormControl';
import Heading from '@/components/Heading';
import useSearchForm from '@/hooks/useSearchForm';
import Travellers from '../Travellers';
import DepartingFromAndDateRange from './components/DepartingFromAndDateRange';
import Hint from './components/Hint';
import NoResults from './components/NoResults';

const SearchButton = styled(Button)`
  min-width: 168px;
  height: 48px;
`;

const SearchPanel = React.memo(() => {
  const {
    data,
    error,
    changeRoute,
    changeDateRange,
    changeTravellers,
    submit,
  } = useSearchForm();

  const [submitError, setSubmitError] = useState(false);

  const { origin, departureDate, returnDate } = data;

  const occupants = mapOccupants(data.occupants);

  const submitForm = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (Object.values(error).every((v) => !v)) {
      submit();
    } else {
      setSubmitError(true);
    }
  };
  const [onCalendarFocus, setCalendarFocus] = useState(false);

  return (
    <form>
      <Box mb={4}>
        <Heading.h4 fontSize={['md', null, 'lg']}>
          Search for your holiday package
        </Heading.h4>
      </Box>
      <Flex data-testid="SEARCH_PANEL" flexDirection={['column', null, 'row']}>
        <DepartingFromAndDateRange
          originCode={origin && origin.code}
          departureDate={departureDate}
          returnDate={returnDate}
          onChangeRoute={changeRoute}
          onChangeDateRange={changeDateRange}
          calendarFocused={onCalendarFocus}
          error={submitError ? error : {}}
          onCalendarFocus={setCalendarFocus}
        />
        <Box m={2} />
        <Box>
          <Travellers
            occupants={occupants}
            onSubmit={changeTravellers}
            error={submitError ? error : {}}
          />
        </Box>

        <Box m={['0', null, '3']} mb={4} />
        <FormControl flex={[1, 0, 0]} htmlFor="submit" label="">
          <SearchButton
            id="submit"
            variant="primary"
            onClick={submitForm}
            mt={[null, null, 6]}
          >
            Search
          </SearchButton>
        </FormControl>
      </Flex>
    </form>
  );
});

SearchPanel.Hint = Hint;
SearchPanel.NoResults = NoResults;

export default SearchPanel;
